import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  fr: {
    translation: {
      brand: { slogan: "La plateforme immobilière du futur", trust: "IMORA, trouvez votre bien en toute confiance." },
      nav: { home: "Accueil", search: "Recherche", map: "Carte", publish: "Publier", dashboard: "Tableau de bord", admin: "Admin", login: "Se connecter", logout: "Déconnexion", contact: "Contact", payments: "Paiements", feedback: "Avis", assistant: "Assistant IA", profile: "Profil", favorites: "Favoris", archives: "Vendus & Loués" },
      home: {
        heroTitle: "Trouvez votre bien immobilier au Tchad",
        heroSub: "Achetez, vendez ou louez en toute confiance. Terrains, maisons, villas, locaux commerciaux.",
        searchCta: "Rechercher un bien", publishCta: "Publier une annonce",
        featured: "Annonces en vedette", verified: "Biens vérifiés", recent: "Récemment publiées", popularNeigh: "Quartiers populaires",
        whyImora: "Pourquoi IMORA ?",
        trust1: "Annonces vérifiées", trust1d: "Badges officiels après vérification documents",
        trust2: "Carte GPS", trust2d: "Localisation précise sur OpenStreetMap",
        trust3: "Assistant IA", trust3d: "Trouvez le bien idéal en discutant",
        trust4: "Paiement local", trust4d: "Airtel Money et Moov Money supportés",
        viewAll: "Voir tout", noResults: "Aucun bien pour le moment.",
      },
      search: { title: "Recherche avancée", placeholder: "Que cherchez-vous ?", filters: "Filtres", city: "Ville", arrondissement: "Arrondissement", neighborhood: "Quartier", propertyType: "Type de bien", transactionType: "Transaction", minPrice: "Prix min (XAF)", maxPrice: "Prix max (XAF)", minArea: "Superficie min (m²)", verifiedOnly: "Biens vérifiés uniquement", apply: "Appliquer", reset: "Réinitialiser", results: "résultats", noResults: "Aucun bien trouvé. Essayez d'autres filtres." },
      card: { verified: "Vérifié", negotiable: "Négociable", views: "vues", contacts: "contacts", perMonth: "/mois", perDay: "/jour", perWeek: "/semaine", perYear: "/an" },
      detail: {
        description: "Description", details: "Caractéristiques", rooms: "Chambres", bathrooms: "Salles de bain", livingRooms: "Salons",
        landArea: "Superficie terrain", livingArea: "Superficie habitable", location: "Localisation",
        contact: "Contacter le propriétaire", call: "Appeler", whatsapp: "WhatsApp", email: "Email", message: "Envoyer un message",
        favorite: "Ajouter aux favoris", unfavorite: "Retirer", documents: "Documents",
        verified: "Bien vérifié par IMORA", verifiedDesc: "Documents et identité du propriétaire vérifiés.",
        share: "Partager", report: "Signaler", virtualTour: "Visite virtuelle", videoTour: "Vidéo",
        publishedOn: "Publiée le", publishedBy: "Publiée par", views: "vues", similar: "Biens similaires",
        notFound: "Cette annonce n'existe plus ou a été retirée.",
      },
      publish: {
        title: "Publier une annonce",
        step1: "Type & Transaction", step2: "Localisation", step3: "Détails & Prix", step4: "Photos & Documents", step5: "Contact",
        submit: "Publier l'annonce", submitting: "Publication en cours…",
        titleField: "Titre de l'annonce", titlePlaceholder: "Ex. Belle villa 4 chambres à Klémat avec jardin",
        desc: "Description", descPlaceholder: "Décrivez le bien : caractéristiques, équipements, environnement, atouts…",
        price: "Prix (XAF)", negotiable: "Prix négociable",
        uploadPhotos: "Ajouter des photos", takePhoto: "Prendre une photo", uploadVideo: "Ajouter une vidéo",
        visibility: "Visibilité de la localisation", visExact: "Adresse exacte", visNeigh: "Quartier uniquement", visApprox: "Localisation approximative",
        next: "Suivant", back: "Précédent",
        contactName: "Votre nom", contactPhone: "Téléphone", contactWhatsapp: "WhatsApp", contactEmail: "Email",
        success: "Annonce publiée avec succès !",
        successPending: "Annonce soumise ! Elle sera publiée après validation par l'administrateur (sous 24h).",
        needLogin: "Connectez-vous pour publier",
        fixErrors: "Vérifiez les champs en rouge avant de publier.",
        fixErrorsStep: "Vérifiez les champs en rouge avant de continuer.",
        gpsOk: "Position GPS récupérée",
        gpsFail: "Impossible d'obtenir votre position",
        useGps: "Utiliser ma position GPS",
        chooseOption: "— Choisissez —",
        address: "Adresse",
        addressPlaceholder: "Adresse complète (optionnel)",
        rooms: "Chambres", bathrooms: "Salles de bain", livingRooms: "Salons",
        landArea: "Superficie terrain (m²)", livingArea: "Superficie habitable (m²)",
        addPhoto: "Ajouter", removePhoto: "Retirer",
        photoHint: "Photos claires et lumineuses — max 10 photos, compressées automatiquement",
        docHint: "Titre foncier, arrêté d'attribution ou tout document utile (PDF, JPG)",
        virtualTourUrl: "Lien visite virtuelle (Matterport, YouTube, etc.)",
        err: {
          typeRequired: "Veuillez choisir le type de bien.",
          transactionRequired: "Veuillez choisir le type de transaction.",
          titleRequired: "Le titre est requis.",
          titleShort: "Le titre est trop court (min. 8 caractères).",
          titleLong: "Le titre est trop long (max. 120 caractères).",
          descRequired: "La description est requise.",
          descShort: "Décrivez votre bien plus en détail (min. 30 caractères).",
          cityRequired: "Veuillez choisir une ville.",
          neighRequired: "Veuillez choisir un quartier.",
          latInvalid: "Latitude invalide.",
          lngInvalid: "Longitude invalide.",
          priceInvalid: "Le prix doit être supérieur à 0.",
          priceTooHigh: "Le prix semble incohérent. Vérifiez votre saisie.",
          roomsRequired: "Indiquez le nombre de chambres.",
          areaRequired: "Indiquez la superficie (terrain ou habitable).",
          photoRequired: "Ajoutez au moins une photo du bien.",
          nameRequired: "Veuillez indiquer votre nom.",
          phoneRequired: "Le numéro de téléphone est requis.",
          phoneInvalid: "Numéro invalide (ex. +235 64 92 73 80).",
          whatsappInvalid: "Numéro WhatsApp invalide.",
          emailInvalid: "Email invalide.",
        },
      },
      dashboard: {
        mine: "Mes annonces", favorites: "Mes favoris", messages: "Mes messages", stats: "Statistiques",
        notifications: "Notifications", analytics: "Analytique",
        role: "Rôle", noMine: "Aucune annonce pour l'instant.", noFav: "Aucun favori pour l'instant.", noNotif: "Aucune notification.",
        views: "Vues", contacts: "Contacts", revenue: "Revenus",
        profile: "Profil", saveProfile: "Enregistrer", profileUpdated: "Profil mis à jour",
        deletePrompt: "Supprimer cette annonce ?", deleted: "Annonce supprimée",
        edit: "Modifier", delete: "Supprimer",
        agencyName: "Nom de l'agence", phone: "Téléphone", whatsapp: "WhatsApp",
      },
      admin: { dashboard: "Tableau de bord admin", users: "Utilisateurs", agencies: "Agences", properties: "Annonces", verifications: "Vérifications", payments: "Paiements", stats: "Statistiques", totalUsers: "Utilisateurs", totalAgencies: "Agences", totalProperties: "Annonces", verifiedProperties: "Vérifiées", revenue: "Revenus", activeSessions: "Sessions actives", pending: "En attente", verify: "Vérifier", unverify: "Retirer vérification", suspend: "Suspendre", unsuspend: "Réactiver", confirm: "Confirmer", reject: "Rejeter", feedback: "Retours utilisateurs", makeFeatured: "Mettre en avant" },
      login: { title: "Se connecter à IMORA", subtitle: "Accédez à votre tableau de bord, publiez et gérez vos annonces.", continueGoogle: "Continuer avec Google", terms: "En continuant, vous acceptez nos conditions d'utilisation." },
      ai: { title: "IMORA Assistant", subtitle: "Votre conseiller immobilier intelligent", placeholder: "Posez votre question…", send: "Envoyer", thinking: "Je réfléchis…", greeting: "Bonjour ! Je suis IMORA Assistant. Comment puis-je vous aider à trouver votre bien idéal ?" },
      contact: {
        title: "Contactez IMORA", subtitle: "Notre équipe est à votre écoute",
        phone: "Téléphone", whatsapp: "WhatsApp", email: "E-mail",
        social: "Réseaux sociaux",
        message: "Nous écrire", messagePlaceholder: "Votre message…", send: "Envoyer",
      },
      payments: { title: "Paiements IMORA", subtitle: "Réglez vos services avec Airtel Money ou Moov Money", howto: "Comment payer", step1: "Envoyez le montant via Airtel Money ou Moov Money au numéro ci-dessous", step2: "Notez l'ID de transaction reçu par SMS", step3: "Soumettez le formulaire avec votre ID de transaction", step4: "Notre équipe valide sous 24h ouvrées", airtelNum: "Numéro Airtel Money", moovNum: "Numéro Moov Money", type: "Type de service", amount: "Montant (XAF)", method: "Méthode", transactionId: "ID de transaction", payerPhone: "Votre numéro payeur", note: "Note (facultatif)", submit: "Soumettre le paiement", history: "Mes paiements" },
      feedback: { title: "Avis & Retours", subtitle: "Aidez-nous à améliorer IMORA", name: "Nom", email: "Email (facultatif)", phone: "Téléphone (facultatif)", type: "Type de retour", rating: "Note (1-5 étoiles)", message: "Votre message", submit: "Envoyer", suggestion: "Suggestion", issue: "Signaler un problème", feature: "Demande de fonctionnalité", report: "Signaler une annonce", thanks: "Merci pour votre retour !" },
      archives: {
        title: "Vendus & Loués",
        badge: "Transactions réussies",
        subtitle: "Découvrez les biens immobiliers déjà vendus ou loués via IMORA Tchad. La preuve sociale de notre plateforme et l'historique de nos transactions réussies.",
        sold: "Vendus", rented: "Loués", totalLabel: "Total",
        inYear: "En {{year}}",
        topNeighborhoods: "Quartiers les plus actifs",
        allYears: "Toutes années",
        empty: "Aucun bien archivé pour le moment.",
        emptyFilter: "Aucun bien archivé pour ces critères.",
        testimonial: "Témoignage client",
      },
      map: { title: "Carte des biens", subtitle: "Explorez tous les biens géolocalisés au Tchad", yourPosition: "Votre position", noGps: "GPS non disponible" },
      common: { loading: "Chargement…", error: "Une erreur est survenue", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", confirm: "Confirmer", yes: "Oui", no: "Non", all: "Tous", filter: "Filtrer", close: "Fermer", language: "Langue", from: "à partir de", or: "ou", required: "requis", optional: "facultatif", loadMore: "Afficher plus", loading_more: "Chargement…" },
      scam: {
        title: "⚠️ Attention aux arnaques",
        body: "Ne versez JAMAIS d'argent (acompte, frais de visite ou réservation) par Mobile Money sans avoir visité le bien et rencontré l'agent en personne. IMORA ne garantit pas les transactions à distance.",
        short: "Ne payez jamais avant d'avoir visité le bien en personne.",
      },
      report: {
        button: "Signaler cette annonce",
        buttonShort: "Signaler",
        title: "Signaler cette annonce",
        subtitle: "Aidez-nous à protéger la communauté IMORA. Votre signalement reste confidentiel.",
        reasonLabel: "Motif du signalement",
        reason: {
          scam: "Suspicion d'arnaque",
          fake: "Fausse annonce / photos volées",
          price: "Prix ou description trompeurs",
          soldRented: "Bien déjà vendu ou loué",
          duplicate: "Doublon",
          inappropriate: "Contenu inapproprié",
          other: "Autre",
        },
        detailsLabel: "Détails (facultatif)",
        detailsPlaceholder: "Décrivez ce qui vous semble suspect…",
        contactLabel: "Vos coordonnées (facultatif — pour vous recontacter)",
        namePlaceholder: "Votre nom",
        phonePlaceholder: "Téléphone",
        emailPlaceholder: "Email",
        submit: "Envoyer le signalement",
        submitting: "Envoi…",
        success: "Merci ! Votre signalement a été transmis à l'administration IMORA.",
        errorReason: "Merci de choisir un motif.",
      },
      terms: {
        title: "Conditions générales d'utilisation",
        lastUpdated: "Dernière mise à jour : 15 février 2026",
      },
    },
  },
  en: {
    translation: {
      brand: { slogan: "The future real estate platform", trust: "IMORA, find your property with confidence." },
      nav: { home: "Home", search: "Search", map: "Map", publish: "Publish", dashboard: "Dashboard", admin: "Admin", login: "Sign in", logout: "Sign out", contact: "Contact", payments: "Payments", feedback: "Feedback", assistant: "AI Assistant", profile: "Profile", favorites: "Favorites", archives: "Sold & Rented" },
      home: {
        heroTitle: "Find your property in Chad",
        heroSub: "Buy, sell or rent with confidence. Land, houses, villas, commercial spaces.",
        searchCta: "Search properties", publishCta: "Publish a listing",
        featured: "Featured listings", verified: "Verified properties", recent: "Recently published", popularNeigh: "Popular neighborhoods",
        whyImora: "Why IMORA?",
        trust1: "Verified listings", trust1d: "Official badges after document checks",
        trust2: "GPS map", trust2d: "Precise location on OpenStreetMap",
        trust3: "AI Assistant", trust3d: "Find the perfect property by chatting",
        trust4: "Local payments", trust4d: "Airtel Money & Moov Money supported",
        viewAll: "View all", noResults: "No listings yet.",
      },
      search: { title: "Advanced search", placeholder: "What are you looking for?", filters: "Filters", city: "City", arrondissement: "District", neighborhood: "Neighborhood", propertyType: "Property type", transactionType: "Transaction", minPrice: "Min price (XAF)", maxPrice: "Max price (XAF)", minArea: "Min area (m²)", verifiedOnly: "Verified only", apply: "Apply", reset: "Reset", results: "results", noResults: "No properties found. Try different filters." },
      card: { verified: "Verified", negotiable: "Negotiable", views: "views", contacts: "contacts", perMonth: "/month", perDay: "/day", perWeek: "/week", perYear: "/year" },
      detail: {
        description: "Description", details: "Specs", rooms: "Bedrooms", bathrooms: "Bathrooms", livingRooms: "Living rooms",
        landArea: "Land area", livingArea: "Living area", location: "Location",
        contact: "Contact owner", call: "Call", whatsapp: "WhatsApp", email: "Email", message: "Send message",
        favorite: "Add to favorites", unfavorite: "Remove", documents: "Documents",
        verified: "Property verified by IMORA", verifiedDesc: "Documents and owner identity verified.",
        share: "Share", report: "Report", virtualTour: "Virtual tour", videoTour: "Video",
        publishedOn: "Published on", publishedBy: "Published by", views: "views", similar: "Similar properties",
        notFound: "This listing no longer exists or was removed.",
      },
      publish: {
        title: "Publish a listing",
        step1: "Type & Transaction", step2: "Location", step3: "Details & Price", step4: "Photos & Documents", step5: "Contact",
        submit: "Publish listing", submitting: "Publishing…",
        titleField: "Listing title", titlePlaceholder: "e.g. Beautiful 4-bedroom villa in Klémat with garden",
        desc: "Description", descPlaceholder: "Describe the property: features, amenities, area, highlights…",
        price: "Price (XAF)", negotiable: "Negotiable price",
        uploadPhotos: "Upload photos", takePhoto: "Take a photo", uploadVideo: "Upload video",
        visibility: "Location visibility", visExact: "Exact address", visNeigh: "Neighborhood only", visApprox: "Approximate location",
        next: "Next", back: "Back",
        contactName: "Your name", contactPhone: "Phone", contactWhatsapp: "WhatsApp", contactEmail: "Email",
        success: "Listing published successfully!",
        successPending: "Listing submitted! It will be published after admin validation (within 24h).",
        needLogin: "Sign in to publish",
        fixErrors: "Please fix the fields in red before publishing.",
        fixErrorsStep: "Please fix the fields in red before continuing.",
        gpsOk: "GPS position retrieved",
        gpsFail: "Unable to get your location",
        useGps: "Use my GPS location",
        chooseOption: "— Choose —",
        address: "Address",
        addressPlaceholder: "Full address (optional)",
        rooms: "Bedrooms", bathrooms: "Bathrooms", livingRooms: "Living rooms",
        landArea: "Land area (m²)", livingArea: "Living area (m²)",
        addPhoto: "Add", removePhoto: "Remove",
        photoHint: "Clear, bright photos — up to 10, auto-compressed",
        docHint: "Land title, allocation order or any useful document (PDF, JPG)",
        virtualTourUrl: "Virtual tour link (Matterport, YouTube, etc.)",
        err: {
          typeRequired: "Please choose the property type.",
          transactionRequired: "Please choose the transaction type.",
          titleRequired: "Title is required.",
          titleShort: "Title too short (min. 8 characters).",
          titleLong: "Title too long (max. 120 characters).",
          descRequired: "Description is required.",
          descShort: "Please describe your property in more detail (min. 30 characters).",
          cityRequired: "Please choose a city.",
          neighRequired: "Please choose a neighborhood.",
          latInvalid: "Invalid latitude.",
          lngInvalid: "Invalid longitude.",
          priceInvalid: "Price must be greater than 0.",
          priceTooHigh: "Price seems inconsistent. Please check.",
          roomsRequired: "Please indicate the number of bedrooms.",
          areaRequired: "Please indicate the area (land or living).",
          photoRequired: "Add at least one photo of the property.",
          nameRequired: "Please provide your name.",
          phoneRequired: "Phone number is required.",
          phoneInvalid: "Invalid number (e.g. +235 64 92 73 80).",
          whatsappInvalid: "Invalid WhatsApp number.",
          emailInvalid: "Invalid email.",
        },
      },
      dashboard: {
        mine: "My listings", favorites: "My favorites", messages: "My messages", stats: "Stats",
        notifications: "Notifications", analytics: "Analytics",
        role: "Role", noMine: "No listings yet.", noFav: "No favorites yet.", noNotif: "No notifications.",
        views: "Views", contacts: "Contacts", revenue: "Revenue",
        profile: "Profile", saveProfile: "Save", profileUpdated: "Profile updated",
        deletePrompt: "Delete this listing?", deleted: "Listing deleted",
        edit: "Edit", delete: "Delete",
        agencyName: "Agency name", phone: "Phone", whatsapp: "WhatsApp",
      },
      admin: { dashboard: "Admin dashboard", users: "Users", agencies: "Agencies", properties: "Listings", verifications: "Verifications", payments: "Payments", stats: "Statistics", totalUsers: "Users", totalAgencies: "Agencies", totalProperties: "Listings", verifiedProperties: "Verified", revenue: "Revenue", activeSessions: "Active sessions", pending: "Pending", verify: "Verify", unverify: "Unverify", suspend: "Suspend", unsuspend: "Reactivate", confirm: "Confirm", reject: "Reject", feedback: "User feedback", makeFeatured: "Feature" },
      login: { title: "Sign in to IMORA", subtitle: "Access your dashboard, publish and manage listings.", continueGoogle: "Continue with Google", terms: "By continuing you accept our terms of use." },
      ai: { title: "IMORA Assistant", subtitle: "Your smart real estate advisor", placeholder: "Ask anything…", send: "Send", thinking: "Thinking…", greeting: "Hello! I'm IMORA Assistant. How can I help you find the perfect property?" },
      contact: {
        title: "Contact IMORA", subtitle: "Our team is here to help",
        phone: "Phone", whatsapp: "WhatsApp", email: "Email",
        social: "Social media",
        message: "Write to us", messagePlaceholder: "Your message…", send: "Send",
      },
      payments: { title: "IMORA Payments", subtitle: "Pay with Airtel Money or Moov Money", howto: "How to pay", step1: "Send the amount via Airtel or Moov Money to the number below", step2: "Save the transaction ID from your SMS", step3: "Submit the form with your transaction ID", step4: "Our team validates within 24h", airtelNum: "Airtel Money number", moovNum: "Moov Money number", type: "Service type", amount: "Amount (XAF)", method: "Method", transactionId: "Transaction ID", payerPhone: "Your phone", note: "Note (optional)", submit: "Submit payment", history: "My payments" },
      feedback: { title: "Feedback", subtitle: "Help us improve IMORA", name: "Name", email: "Email (optional)", phone: "Phone (optional)", type: "Feedback type", rating: "Rating (1-5)", message: "Your message", submit: "Send", suggestion: "Suggestion", issue: "Report issue", feature: "Feature request", report: "Report listing", thanks: "Thank you!" },
      archives: {
        title: "Sold & Rented",
        badge: "Successful transactions",
        subtitle: "Discover the properties already sold or rented via IMORA Chad. The social proof of our platform and the history of our successful transactions.",
        sold: "Sold", rented: "Rented", totalLabel: "Total",
        inYear: "In {{year}}",
        topNeighborhoods: "Most active neighborhoods",
        allYears: "All years",
        empty: "No archived properties yet.",
        emptyFilter: "No archived properties matching these filters.",
        testimonial: "Client testimonial",
      },
      map: { title: "Property map", subtitle: "Explore all geo-located properties in Chad", yourPosition: "Your position", noGps: "GPS unavailable" },
      common: { loading: "Loading…", error: "An error occurred", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", confirm: "Confirm", yes: "Yes", no: "No", all: "All", filter: "Filter", close: "Close", language: "Language", from: "from", or: "or", required: "required", optional: "optional", loadMore: "Load more", loading_more: "Loading…" },
      scam: {
        title: "⚠️ Beware of scams",
        body: "NEVER send money (deposit, viewing fee or reservation) via Mobile Money before visiting the property and meeting the agent in person. IMORA does not guarantee remote transactions.",
        short: "Never pay before visiting the property in person.",
      },
      report: {
        button: "Report this listing",
        buttonShort: "Report",
        title: "Report this listing",
        subtitle: "Help us protect the IMORA community. Your report stays confidential.",
        reasonLabel: "Reason",
        reason: {
          scam: "Suspected scam",
          fake: "Fake listing / stolen photos",
          price: "Misleading price or description",
          soldRented: "Already sold or rented",
          duplicate: "Duplicate",
          inappropriate: "Inappropriate content",
          other: "Other",
        },
        detailsLabel: "Details (optional)",
        detailsPlaceholder: "Describe what seems suspicious…",
        contactLabel: "Your contact info (optional — so we can reach you)",
        namePlaceholder: "Your name",
        phonePlaceholder: "Phone",
        emailPlaceholder: "Email",
        submit: "Submit report",
        submitting: "Sending…",
        success: "Thank you! Your report was sent to IMORA admins.",
        errorReason: "Please choose a reason.",
      },
      terms: {
        title: "Terms of Service",
        lastUpdated: "Last updated: February 15, 2026",
      },
    },
  },
  ar: {
    translation: {
      brand: { slogan: "منصة العقارات للمستقبل", trust: "إيمورا، اعثر على عقارك بثقة." },
      nav: { home: "الرئيسية", search: "بحث", map: "خريطة", publish: "نشر", dashboard: "لوحة التحكم", admin: "المشرف", login: "تسجيل الدخول", logout: "خروج", contact: "اتصل بنا", payments: "المدفوعات", feedback: "آراء", assistant: "مساعد ذكي", profile: "الملف الشخصي", favorites: "المفضلة", archives: "المُباعة والمؤجرة" },
      home: {
        heroTitle: "ابحث عن عقارك في تشاد",
        heroSub: "اشترِ، بِع أو استأجر بكل ثقة. أراضٍ، منازل، فيلات، محلات تجارية.",
        searchCta: "بحث عن عقار", publishCta: "نشر إعلان",
        featured: "إعلانات مميزة", verified: "عقارات موثقة", recent: "نُشر مؤخرًا", popularNeigh: "الأحياء الشعبية",
        whyImora: "لماذا إيمورا؟",
        trust1: "إعلانات موثقة", trust1d: "شارات رسمية بعد التحقق من الوثائق",
        trust2: "خريطة GPS", trust2d: "موقع دقيق على OpenStreetMap",
        trust3: "مساعد ذكي", trust3d: "تحدث مع المساعد للعثور على عقارك",
        trust4: "دفع محلي", trust4d: "Airtel Money و Moov Money مدعومان",
        viewAll: "عرض الكل", noResults: "لا توجد إعلانات حاليًا.",
      },
      search: { title: "بحث متقدم", placeholder: "ماذا تبحث؟", filters: "تصفية", city: "المدينة", arrondissement: "المنطقة", neighborhood: "الحي", propertyType: "نوع العقار", transactionType: "المعاملة", minPrice: "الحد الأدنى للسعر", maxPrice: "الحد الأقصى للسعر", minArea: "مساحة دنيا (م²)", verifiedOnly: "موثقة فقط", apply: "تطبيق", reset: "إعادة", results: "نتائج", noResults: "لا توجد نتائج. جرّب تصفية أخرى." },
      card: { verified: "موثق", negotiable: "قابل للتفاوض", views: "مشاهدات", contacts: "تواصلات", perMonth: "/شهر", perDay: "/يوم", perWeek: "/أسبوع", perYear: "/سنة" },
      detail: {
        description: "الوصف", details: "المواصفات", rooms: "غرف", bathrooms: "حمامات", livingRooms: "صالات",
        landArea: "مساحة الأرض", livingArea: "المساحة السكنية", location: "الموقع",
        contact: "اتصل بالمالك", call: "اتصال", whatsapp: "واتساب", email: "بريد", message: "أرسل رسالة",
        favorite: "أضف للمفضلة", unfavorite: "إزالة", documents: "وثائق",
        verified: "عقار موثق من إيمورا", verifiedDesc: "تم التحقق من الوثائق وهوية المالك.",
        share: "مشاركة", report: "بلاغ", virtualTour: "جولة افتراضية", videoTour: "فيديو",
        publishedOn: "نُشر بتاريخ", publishedBy: "نشره", views: "مشاهدة", similar: "عقارات مشابهة",
        notFound: "هذا الإعلان لم يعد متاحًا.",
      },
      publish: {
        title: "نشر إعلان",
        step1: "النوع والمعاملة", step2: "الموقع", step3: "التفاصيل والسعر", step4: "الصور والوثائق", step5: "الاتصال",
        submit: "نشر الإعلان", submitting: "جارٍ النشر…",
        titleField: "عنوان الإعلان", titlePlaceholder: "مثال: فيلا جميلة بأربع غرف في كليمات مع حديقة",
        desc: "الوصف", descPlaceholder: "صف العقار: المواصفات والتجهيزات والمحيط والمزايا…",
        price: "السعر (XAF)", negotiable: "سعر قابل للتفاوض",
        uploadPhotos: "إضافة صور", takePhoto: "التقاط صورة", uploadVideo: "إضافة فيديو",
        visibility: "رؤية الموقع", visExact: "العنوان الدقيق", visNeigh: "الحي فقط", visApprox: "موقع تقريبي",
        next: "التالي", back: "السابق",
        contactName: "اسمك", contactPhone: "الهاتف", contactWhatsapp: "واتساب", contactEmail: "البريد الإلكتروني",
        success: "تم نشر الإعلان بنجاح!",
        successPending: "تم إرسال الإعلان! سيُنشر بعد التحقق من قِبَل المشرف (خلال 24 ساعة).",
        needLogin: "سجّل الدخول للنشر",
        fixErrors: "يرجى تصحيح الحقول الحمراء قبل النشر.",
        fixErrorsStep: "يرجى تصحيح الحقول الحمراء قبل المتابعة.",
        gpsOk: "تم تحديد موقع GPS",
        gpsFail: "تعذّر الحصول على موقعك",
        useGps: "استخدم موقع GPS",
        chooseOption: "— اختر —",
        address: "العنوان",
        addressPlaceholder: "العنوان الكامل (اختياري)",
        rooms: "غرف", bathrooms: "حمامات", livingRooms: "صالات",
        landArea: "مساحة الأرض (م²)", livingArea: "المساحة السكنية (م²)",
        addPhoto: "إضافة", removePhoto: "حذف",
        photoHint: "صور واضحة وساطعة — حتى 10 صور، مضغوطة تلقائيًا",
        docHint: "سند الملكية أو أي وثيقة مفيدة (PDF، JPG)",
        virtualTourUrl: "رابط جولة افتراضية (Matterport، YouTube، إلخ)",
        err: {
          typeRequired: "يرجى اختيار نوع العقار.",
          transactionRequired: "يرجى اختيار نوع المعاملة.",
          titleRequired: "العنوان مطلوب.",
          titleShort: "العنوان قصير جدًا (8 أحرف على الأقل).",
          titleLong: "العنوان طويل جدًا (120 حرفًا كحد أقصى).",
          descRequired: "الوصف مطلوب.",
          descShort: "يرجى وصف العقار بمزيد من التفصيل (30 حرفًا على الأقل).",
          cityRequired: "يرجى اختيار مدينة.",
          neighRequired: "يرجى اختيار حي.",
          latInvalid: "خط عرض غير صالح.",
          lngInvalid: "خط طول غير صالح.",
          priceInvalid: "يجب أن يكون السعر أكبر من 0.",
          priceTooHigh: "السعر يبدو غير منطقي. يرجى التحقق.",
          roomsRequired: "يرجى تحديد عدد الغرف.",
          areaRequired: "يرجى تحديد المساحة (أرض أو سكنية).",
          photoRequired: "أضف صورة واحدة على الأقل للعقار.",
          nameRequired: "يرجى إدخال اسمك.",
          phoneRequired: "رقم الهاتف مطلوب.",
          phoneInvalid: "رقم غير صالح (مثال: +235 64 92 73 80).",
          whatsappInvalid: "رقم واتساب غير صالح.",
          emailInvalid: "بريد إلكتروني غير صالح.",
        },
      },
      dashboard: {
        mine: "إعلاناتي", favorites: "مفضلتي", messages: "رسائلي", stats: "إحصاءات",
        notifications: "الإشعارات", analytics: "التحليلات",
        role: "الدور", noMine: "لا توجد إعلانات بعد.", noFav: "لا توجد مفضلات بعد.", noNotif: "لا توجد إشعارات.",
        views: "مشاهدات", contacts: "تواصلات", revenue: "إيرادات",
        profile: "الملف الشخصي", saveProfile: "حفظ", profileUpdated: "تم تحديث الملف",
        deletePrompt: "حذف هذا الإعلان؟", deleted: "تم حذف الإعلان",
        edit: "تعديل", delete: "حذف",
        agencyName: "اسم الوكالة", phone: "الهاتف", whatsapp: "واتساب",
      },
      admin: { dashboard: "لوحة المشرف", users: "المستخدمون", agencies: "الوكالات", properties: "الإعلانات", verifications: "التحقق", payments: "المدفوعات", stats: "الإحصاءات", totalUsers: "المستخدمون", totalAgencies: "الوكالات", totalProperties: "الإعلانات", verifiedProperties: "موثقة", revenue: "إيرادات", activeSessions: "جلسات نشطة", pending: "قيد الانتظار", verify: "توثيق", unverify: "إلغاء التوثيق", suspend: "تعليق", unsuspend: "إعادة تفعيل", confirm: "تأكيد", reject: "رفض", feedback: "ملاحظات", makeFeatured: "إبراز" },
      login: { title: "تسجيل الدخول إلى إيمورا", subtitle: "ادخل إلى لوحتك وانشر وأدر إعلاناتك.", continueGoogle: "المتابعة بـ Google", terms: "بالمتابعة فإنك توافق على شروط الاستخدام." },
      ai: { title: "مساعد إيمورا", subtitle: "مستشارك العقاري الذكي", placeholder: "اطرح سؤالك…", send: "إرسال", thinking: "أفكر…", greeting: "أهلاً! أنا مساعد إيمورا. كيف أساعدك في العثور على عقارك المثالي؟" },
      contact: {
        title: "اتصل بإيمورا", subtitle: "فريقنا في خدمتك",
        phone: "الهاتف", whatsapp: "واتساب", email: "البريد الإلكتروني",
        social: "شبكات التواصل",
        message: "راسلنا", messagePlaceholder: "رسالتك…", send: "إرسال",
      },
      payments: { title: "مدفوعات إيمورا", subtitle: "ادفع عبر Airtel أو Moov Money", howto: "كيفية الدفع", step1: "أرسل المبلغ عبر Airtel أو Moov إلى الرقم أدناه", step2: "احفظ معرف المعاملة الذي وصلك عبر SMS", step3: "أرسل النموذج مع معرف المعاملة", step4: "يراجع فريقنا خلال 24 ساعة عمل", airtelNum: "رقم Airtel Money", moovNum: "رقم Moov Money", type: "نوع الخدمة", amount: "المبلغ (XAF)", method: "الطريقة", transactionId: "معرف المعاملة", payerPhone: "هاتفك", note: "ملاحظة (اختياري)", submit: "إرسال الدفع", history: "مدفوعاتي" },
      feedback: { title: "ملاحظات", subtitle: "ساعدنا في تحسين إيمورا", name: "الاسم", email: "البريد (اختياري)", phone: "الهاتف (اختياري)", type: "نوع الملاحظة", rating: "التقييم (1-5)", message: "رسالتك", submit: "إرسال", suggestion: "اقتراح", issue: "الإبلاغ عن مشكلة", feature: "طلب ميزة", report: "الإبلاغ عن إعلان", thanks: "شكرًا لملاحظاتك!" },
      archives: {
        title: "المُباعة والمؤجرة",
        badge: "معاملات ناجحة",
        subtitle: "اكتشف العقارات التي بيعت أو أُجّرت عبر إيمورا تشاد. دليل اجتماعي على منصتنا وتاريخ معاملاتنا الناجحة.",
        sold: "مُباعة", rented: "مؤجرة", totalLabel: "الإجمالي",
        inYear: "في {{year}}",
        topNeighborhoods: "الأحياء الأكثر نشاطًا",
        allYears: "كل السنوات",
        empty: "لا توجد عقارات مؤرشفة بعد.",
        emptyFilter: "لا توجد عقارات تطابق هذه التصفية.",
        testimonial: "شهادة عميل",
      },
      map: { title: "خريطة العقارات", subtitle: "استكشف جميع العقارات المحددة جغرافيًا في تشاد", yourPosition: "موقعك", noGps: "GPS غير متاح" },
      common: { loading: "جارٍ التحميل…", error: "حدث خطأ", save: "حفظ", cancel: "إلغاء", delete: "حذف", edit: "تعديل", confirm: "تأكيد", yes: "نعم", no: "لا", all: "الكل", filter: "تصفية", close: "إغلاق", language: "اللغة", from: "من", or: "أو", required: "مطلوب", optional: "اختياري", loadMore: "عرض المزيد", loading_more: "جارٍ التحميل…" },
      scam: {
        title: "⚠️ احذر من عمليات الاحتيال",
        body: "لا تدفع أبدًا (عربون، رسوم زيارة أو حجز) عبر Mobile Money قبل زيارة العقار ولقاء الوسيط شخصيًا. إيمورا لا تضمن المعاملات عن بعد.",
        short: "لا تدفع أبدًا قبل زيارة العقار شخصيًا.",
      },
      report: {
        button: "الإبلاغ عن هذا الإعلان",
        buttonShort: "إبلاغ",
        title: "الإبلاغ عن هذا الإعلان",
        subtitle: "ساعدنا في حماية مجتمع إيمورا. يبقى بلاغك سريًا.",
        reasonLabel: "سبب الإبلاغ",
        reason: {
          scam: "اشتباه بالاحتيال",
          fake: "إعلان مزيّف / صور مسروقة",
          price: "سعر أو وصف مضلل",
          soldRented: "مباع أو مؤجر بالفعل",
          duplicate: "مكرر",
          inappropriate: "محتوى غير لائق",
          other: "آخر",
        },
        detailsLabel: "تفاصيل (اختياري)",
        detailsPlaceholder: "صف ما يبدو مريبًا…",
        contactLabel: "بيانات الاتصال (اختياري — لنعاود الاتصال بك)",
        namePlaceholder: "اسمك",
        phonePlaceholder: "الهاتف",
        emailPlaceholder: "البريد الإلكتروني",
        submit: "إرسال البلاغ",
        submitting: "جارٍ الإرسال…",
        success: "شكرًا لك! تم إرسال بلاغك إلى إدارة إيمورا.",
        errorReason: "الرجاء اختيار سبب.",
      },
      terms: {
        title: "الشروط والأحكام",
        lastUpdated: "آخر تحديث: 15 فبراير 2026",
      },
    },
  },
};

const saved = typeof window !== "undefined" ? localStorage.getItem("imora_lang") : null;

i18n.use(initReactI18next).init({
  resources,
  lng: saved || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export const setLanguage = (lng) => {
  localStorage.setItem("imora_lang", lng);
  i18n.changeLanguage(lng);
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
};

if (typeof window !== "undefined") {
  document.documentElement.dir = (saved || "fr") === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = saved || "fr";
}

export default i18n;
